import { AlternatePlanChangePlanPopupRoute, AlternatePlanRoute } from '../ap_alternate_plan_routes';
const advisorAlternatePlan = {
  ...AlternatePlanRoute,
  template: `
  <advisor-header-view-plan></advisor-header-view-plan>
  <div class="clr-white-bkg pbmxxx"></div>
  <alternate-plans></alternate-plans>
  `
};
export const APAdvisorAlternatePlanRoutes = {
  'ap-advisor.alternate-plans': { ...advisorAlternatePlan },
  'ap-advisor.alternate-plans.change-plan': {
    ...AlternatePlanChangePlanPopupRoute,
    views: {
      'modal@ap-advisor': {
        template: `<alternate-plan-change-plan-popup></alternate-plan-change-plan-popup>`
      }
    }
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/advisor_routes/ap_advisor_alternate_plans_routes.ts